/**
 * Offscreen render target sistemi (renderTargets faz).
 *
 * Kayitli RenderTarget'lari her kare cizer (rt.scene -> rt.rtinstance). RT
 * listesini sahiplenir; Engine.addRenderTarget/removeRenderTarget buraya delege
 * eder. CSS katmanindan sonra calisir (pending bayragi orada tuketilir).
 */
import { Scene, WebGLRenderer } from "three";
import type { RenderTarget } from "../RenderTarget";
import type { EngineSystem, FrameContext, FramePhase } from "../runtime/EngineSystem";

export class RenderTargetSystem implements EngineSystem {
  readonly name = "renderTargetsOffscreen";
  readonly labels: Partial<Record<FramePhase, string>> = {
    renderTargets: "renderTargets.offscreen",
  };

  private _targets: RenderTarget[] = [];

  add(rt: RenderTarget): void {
    this._targets.push(rt);
  }

  remove(rt: RenderTarget | undefined): void {
    this._targets = this._targets.filter((e) => rt != e);
  }

  /** Aktif RT sayisi (structural gauge icin). */
  get count(): number {
    return this._targets.length;
  }

  renderTargets(ctx: FrameContext): void {
    const engine = ctx.engine;
    const renderer = engine.renderer;
    if (!(renderer.instance instanceof WebGLRenderer)) return;

    this._targets.forEach((rt) => {
      rt.beforeRender(rt.scene!, rt.camera!);

      renderer.instance.setRenderTarget(rt.rtinstance);
      renderer.instance.setSize(rt.rtinstance.width, rt.rtinstance.height, false);

      renderer.render(rt.scene as Scene, rt.camera!);

      renderer.instance.setRenderTarget(null!);
      renderer.instance.setSize(engine.width, engine.height, false);
    });
  }
}
